/**
 * Swiper 11.2.10
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 28, 2025
 */

import { S as Swiper } from './swiper-core.min.mjs';
import Navigation from './navigation.min.mjs';
import Pagination from './pagination.min.mjs';
import freeMode from './free-mode.min.mjs';

// Swiper Class
const modules = [Navigation, Pagination, freeMode];
Swiper.use(modules);

export { Swiper, Swiper as default };
